import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { VeniceHandlerName, triggerVeniceCallback } from '../../utils/mobile'
import { serverData } from '../../utils/server-data'
import { browserRedirectTo } from '../../utils/navigate'
import COMMON_FPTI_TAGS from '@/constants/fpti-tags/common'
import useAnalytics from '@/hooks/useAnalytics'
import IconPage from 'components/common/IconPage'
const { sessionExpiredImpressionTags, sessionExpiredDoneClickTags } = COMMON_FPTI_TAGS

function SessionExpired({ loginUrl }) {
  const { recordClientClick } = useAnalytics(sessionExpiredImpressionTags)
  const handleOnDone = () => {
    recordClientClick(sessionExpiredDoneClickTags)
    if (serverData.isMobileNative) {
      triggerVeniceCallback(VeniceHandlerName.close)
      return
    }
    browserRedirectTo(loginUrl)
  }

  return (
    <IconPage
      data-testid="session-expired-page"
      headerId="common.sessionExpired.header"
      contentId="common.sessionExpired.content"
      wrapWithModalContent
    >
      <Button data-testid="session-expired-done-button" onClick={handleOnDone}>
        <Message id="common.button.done" />
      </Button>
    </IconPage>
  )
}

SessionExpired.propTypes = {
  loginUrl: PropTypes.string,
}

export default SessionExpired
